import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { TipoDanno } from 'src/app/models/tipo-danno';
import { TipoDannoService } from 'src/app/services/tipo-danno.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { TipiDannoFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'tipi-danno',
  templateUrl: './tipi-danno.component.html',
  styleUrls: ['./tipi-danno.component.scss']
})
export class TipiDannoComponent implements OnInit {

  headingText: string = 'Tipi di danno';


  relations: string[] = ['gruppo_tipi_danno'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  multipleSelection: boolean = false;
  selectionMode: boolean = false;
  showReset: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      },
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Gruppo tipi di danno',
        internalName: 'gruppo tipi di danno',
        sortDisabled: true,
        displayFunction: (model) => model?.gruppo_tipi_danno?.humanIdentifier,
      },
    ),

  ];
  constructor(public tipoDannoService: TipoDannoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    private fb: FormBuilder,
    @Optional() private dialogRef: MatDialogRef<TipiDannoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {

    if (this.data?.selectionMode || this.data?.multipleSelection) {
      this.selectionMode = this.data?.selectionMode;
      this.multipleSelection = this.data?.multipleSelection;
      this.showReset = this.data?.showReset;
      this.headingText = 'Seleziona un tipo di danno';
    }
  }

  form: FormGroup;

  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  save() {
    this.dialogRef?.close(this.index?.selection?.selected);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (tipoDanno: TipoDanno) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il tipo di danno ${tipoDanno.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.tipoDannoService.delete(tipoDanno);
          this.toast.success('Tipo di danno eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione tipo di danno fallita.", "Errore!");
    }
  }



  editFunction = async (tipoDanno: TipoDanno) => {
    try {
      let dialogRef = this.dialog.open(TipiDannoFormComponent, { data: tipoDanno });
      dialogRef.afterClosed().subscribe(async (data: TipoDanno) => {
        if (data) {

          Object.assign(tipoDanno, data);

          await this.tipoDannoService.edit(tipoDanno);

          this.toast.success('Tipo di danno modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica tipo di danno fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(TipiDannoFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(tipoDanno?: TipoDanno) {
    if (tipoDanno) {
      try {
        await this.tipoDannoService.create(tipoDanno)
        this.toast.success('Tipo di danno creato!')
      }
      catch (e) {
        this.toast.error('Creazione tipo di danno fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }

}
